import Completed from './completed';
import InProgress from './in-progress';
import Withdrawals from './withdrawals';
import React from 'react';

export const tabs: Record<string, string | React.FC>[] = [
  {
    title: 'Active Offers',
    Component: InProgress
  },
  {
    title: 'Rewards History',
    Component: Completed
  },
  {
    title: 'Withdrawals History',
    Component: Withdrawals
  }
];
